import { useQueryClient } from '@tanstack/react-query';
import { ASSET_MEASUREMENTS_LOOKUP_QUERY_KEY } from 'modules/queries/asset/measurements/useLookup';
import { ASSET_DETAILS_QUERY_KEY } from 'modules/queries/asset/useDetails';
import { ASSET_CONNECTIONS_QUERY_KEY } from 'modules/queries/asset/useConnections';
import { ASSET_LIST_QUERY_KEY } from 'modules/queries/asset/useList';

const useInvalidateAssets = () => {
	const queryClient = useQueryClient();

	return (uniqId: string) => {
		queryClient.invalidateQueries({
			queryKey: [ASSET_LIST_QUERY_KEY],
		});

		if (uniqId) {
			queryClient.invalidateQueries({
				queryKey: [ASSET_DETAILS_QUERY_KEY, { uniq_id: uniqId }],
			});
			queryClient.invalidateQueries({
				queryKey: [ASSET_CONNECTIONS_QUERY_KEY, { uniq_id: uniqId }],
			});
			queryClient.invalidateQueries({
				queryKey: [ASSET_MEASUREMENTS_LOOKUP_QUERY_KEY, { uniq_id: uniqId }],
			});
		}
	};
};

export default useInvalidateAssets;
